import { useQuery, type ApolloError } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { type CoSupervisorInformation } from './types';

type GetCoSupervisorInformation = {
  coSupervisorInformation: CoSupervisorInformation;
  guestLoginData: string | null;
  loading: boolean;
  error: ApolloError | undefined;
};

export const useGetCoSupervisorInformation = (
  token: string,
): GetCoSupervisorInformation => {
  const { data, loading, error } = useQuery(
    gql`
      query ($token: String!) {
        getCoSupervisorInformation(token: $token) {
          applicationId
          nominationId
          netId
          emailAddress
          accessToken
        }
      }
    `,
    {
      variables: { token },
      skip: !token,
      fetchPolicy: 'no-cache',
    },
  );

  const coSupervisorInformation: CoSupervisorInformation =
    data?.getCoSupervisorInformation ?? {
      applicationId: '',
      nominationId: '',
      netId: '',
      emailAddress: '',
    };

  return {
    coSupervisorInformation,
    guestLoginData: data?.getCoSupervisorInformation?.accessToken ?? null,
    loading,
    error,
  };
};
